import About from "./components/About";
import Hero from "./components/Hero";
import Loader from "./components/Loader/Loader";
import NavBar from "./components/NavBar";
import { useState, useEffect } from "react";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Footer from "./components/Footer";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-bgClr dark:bg-bgClrDark select-none">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <NavBar />
          <main>
            <section id="home">
              <Hero />
            </section>
            <section id="about" className="scroll-mt-20">
              <About />
            </section>
            <section id="experience" className="scroll-mt-20">
              <Experience />
            </section>
            <section id="projects" className="scroll-mt-20">
              <Projects />
            </section>
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
